import { Control, useFieldArray } from 'react-hook-form';

import { ICreateEcosystemForm } from '~/components/EcosystemForm/types';

export const useDownloadableFilesFormController = ({
  control,
}: {
  control: Control<ICreateEcosystemForm>;
}) => {
  const { fields, append, remove } = useFieldArray({
    name: 'downloadableFiles',
    control,
  });

  return {
    fields,
    append,
    remove,
  };
};
